import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { ResponsiveImage } from './ResponsiveImage';
import { Link } from 'react-router-dom';

const logo =
  'https://quoguewildliferefuge.org/wp-content/uploads/2020/11/Quogue-Wildlife-Refuge-2020.png';

export function Navigation() {
  return (
    <View style={style.container}>
      <Link to="/" style={style.logo}>
        <View style={style.logo}>
          <ResponsiveImage uri={logo} />
        </View>
      </Link>
      <Text style={style.text}>Map</Text>
    </View>
  );
}

const style = StyleSheet.create({
  container: {
    height: 60,
    width: '100%',
    paddingHorizontal: 20,
    flexDirection: 'row',
    shadowRadius: 5,
    shadowOpacity: 0.3,
    shadowColor: '#000',
  },
  logo: {
    maxWidth: 200,
    width: '100%',
  },
  text: {
    alignSelf: 'center',
    fontSize: 20,
    borderLeftWidth: 1,
    borderColor: 'black',
    paddingHorizontal: 10,
    marginLeft: 10,
    color: '#0b2c7a',
  },
});
